import React from 'react';
import styled from 'styled-components';

import { Heading3 } from '@ibinder/common-frontend';

import { Flexbox } from '@ibinder/common-frontend';
import { CopyContentToClipBoard } from '@ibinder/ui-common-core';
import { fileCopy } from '@ibinder/common-icons';

interface props {
  label: string;
  value: string | any;
  type?: 'string' | 'user';
  loading?: boolean;
  showCopy?: boolean;
}

const LabelSpan = styled.span`
  color: ${(p) => p.theme.colors.discrete70};
  line-height: 1.5rem;
`;
const ValueSpan = styled.div`
  color: ${(p) => p.theme.colors.discrete100};
  > svg {
    width: 10px;
  }
`;

const StyledFlexbox = styled(Flexbox)`
  > svg {
    margin: 0;
    margin-bottom: 0.5rem;
    width: 100%;
  }
`;

const CopyFlexbox = styled(Flexbox)`
  > svg {
    height: 2.5rem;
    width: 2.5rem;
  }
  height: 2rem;
  cursor: ${({ showCopy }) => (showCopy ? 'pointer' : 'auto')};
`;

export const OrgPropertyDisplay = ({
  label,
  value,
  type = 'string',
  loading,
  showCopy
}: props) => {
  if (loading) {
    return (
      <StyledFlexbox flexDirection="column">
        <Heading3 loading={true} label="Loading...asdfdsafdsafdsfa" />
        <Heading3 loading={true} label="Loading...asdfsdfadsafdsaf" />
      </StyledFlexbox>
    );
  }

  switch (type) {
    case 'user':
      return <div>user</div>;

    default:
    case 'string':
      return (
        <Flexbox flexDirection="column">
          <LabelSpan>{label}</LabelSpan>

          {showCopy ? (
            <CopyContentToClipBoard content={value}>
              <CopyFlexbox alignItems="center" showCopy>
                <ValueSpan>{value}</ValueSpan>
                {fileCopy}
              </CopyFlexbox>
            </CopyContentToClipBoard>
          ) : (
            <CopyFlexbox alignItems="center" showCopy>
              <ValueSpan>{value}</ValueSpan>
            </CopyFlexbox>
          )}
        </Flexbox>
      );
  }
};
